import { useQuery } from "@tanstack/react-query";
import { Send } from "lucide-react";
import { api } from "@/lib/api";

const useJoinUrl = () => useQuery({ queryKey: ["tg-join"], queryFn: () => api.get("/public/telegram").then((r) => r.data), staleTime: 600000 }).data;

const STYLES = {
  strip: "rounded-2xl bg-sky-600 text-white p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-4",
  compact: "rounded-xl border border-sky-200 bg-sky-50 p-4 flex items-center gap-3",
  footer: "flex flex-col items-start gap-3",
};

export const JoinTelegram = ({ variant = "strip" }) => {
  const info = useJoinUrl();
  if (!info?.url) return null;
  const { url } = info;
  const strip = variant === "strip";
  return (
    <div className={STYLES[variant]} data-testid={`join-telegram-${variant}`}>
      {variant !== "footer" && <span className={`shrink-0 rounded-full grid place-items-center ${strip ? "h-12 w-12 bg-white/15" : "h-9 w-9 bg-sky-600 text-white"}`}><Send size={strip ? 22 : 16} /></span>}
      <div className="flex-1">
        <p className={`font-extrabold ${strip ? "text-xl" : variant === "footer" ? "text-white text-sm" : "text-sm text-slate-900"}`}>Join our Telegram for daily deals</p>
        <p className={`text-xs ${strip ? "text-sky-100" : "text-slate-500"}`}>{info.digest ? `Top ${info.count} verified deals every evening.` : "Fresh verified deals as soon as we find them."} Free, no spam.</p>
      </div>
      <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`join-telegram-${variant}-button`}
        className={`font-bold rounded-lg text-center transition-colors ${strip ? "bg-white text-sky-700 hover:bg-sky-50 px-6 py-3" : "bg-sky-600 text-white hover:bg-sky-700 px-4 py-2 text-sm"}`}>Join channel</a>
    </div>
  );
};
